import UserInfo from "../../User/UserInfo";
import CaseAssessorQuestionRecord from "../GetCaseAssessor/CaseAssessorQuestionRecord";

export default class UpdateCaseAssessorMultiRecordList {
    questions: CaseAssessorQuestionRecord[];

    constructor(questions: CaseAssessorQuestionRecord[]) {
        this.questions = questions;
    }
  }